"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manualEntry_2_5 = void 0;
var utils_1 = require("@time-input-polyfill/utils");
var manualEntry_2_5 = function (utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, a11yHasExpectedHtml = utils.a11yHasExpectedHtml, a11yInitialHtml = utils.a11yInitialHtml, hasReturnVal = utils.hasReturnVal;
    describe('Manual entry - 2-5', function () {
        var _loop_1 = function (i) {
            var hr24 = 12 + i;
            it("".concat(i, " ").concat(i, " ").concat(i, " A"), function () {
                loadPrimaryInput({ segment: 'hrs12' })
                    .type("".concat(i))
                    .should('have.value', "0".concat(i, ":30 PM"))
                    .then(a11yHasExpectedHtml(a11yInitialHtml().minutes))
                    .then(hasReturnVal("".concat(hr24, ":30")))
                    .type("".concat(i))
                    .should('have.value', "0".concat(i, ":0").concat(i, " PM"))
                    .then(a11yHasExpectedHtml("<p>".concat(i, ".</p>")))
                    .then(hasReturnVal("".concat(hr24, ":0").concat(i)))
                    .type("".concat(i))
                    .should('have.value', "0".concat(i, ":").concat(i).concat(i, " PM"))
                    .then(a11yHasExpectedHtml(a11yInitialHtml().mode))
                    .then(hasReturnVal("".concat(hr24, ":").concat(i).concat(i)))
                    .type("a")
                    .should('have.value', "0".concat(i, ":").concat(i).concat(i, " AM"))
                    .then(a11yHasExpectedHtml("<p>AM.</p>"))
                    .then(hasReturnVal("".concat((0, utils_1.toLeadingZero)(hr24 - 12), ":").concat(i).concat(i)));
            });
        };
        for (var i = 2; i <= 5; i++) {
            _loop_1(i);
        }
    });
};
exports.manualEntry_2_5 = manualEntry_2_5;
